<template>
  <div class="performance-property">
    <div class="header c:row-between-center">
      <div>{{ title }}</div>
      <div class="date-time">{{ timeString }}</div>
    </div>
    <div class="report c:row-between-center">
      <div class="report-item">
        <span>¥ {{ amount | filterPrice }}</span>
        <span>销售额</span>
      </div>
      <div class="report-item">
        <span>{{ count }}</span>
        <span>销售量</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    timeString: {
      type: String,
      default: "",
    },
    amount: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.performance-property {
  box-sizing: border-box;
  width: 100%;
  height: 126/20rem;
  margin-bottom: 10/40rem;
  padding: 6/40rem 40/40rem 10/40rem;
  background: #fff;
}
.header {
  height: 47/20rem;
  margin-bottom: 10/40rem;
  border-bottom: 1px solid #f1f1f1;
}
.header div:first-child {
  position: relative;
  padding-left: 44/40rem;
  font-size: 28/40rem;
  font-weight: 500;
  color: #333333;
}
.header div:first-child::before {
  content: "";
  width: 20/40rem;
  height: 20/40rem;
  background: #000000;
  position: absolute;
  left: 0;
  top: 10/40rem;
}
.date-time {
  font-size: 24/40rem;
  color: #d8d8d8;
}
.report {
  height: 128/40rem;
}

.report .report-item {
  flex: 1;

  box-sizing: border-box;
  height: 100%;
  padding-top: 5/20rem;
  padding-bottom: 11/20rem;
  text-align: center;
}
.report .report-item:first-child {
  border-right: 1px solid #f1f1f1;
}

.report .report-item span {
  display: block;
}

.report .report-item span:first-child {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 6/20rem;
  color: #333333;
}

.report .report-item span:nth-child(2) {
  font-size: 12/20rem;
  line-height: 17/20rem;
  color: #b3b3b3;
}
</style>
